import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Form, Label } from '@anytag/shared-atoms';
import { TextField } from '@anytag/shared-molecules';
import { cn, formatPercent } from '@anytag/shared-utils';
import { AutoManagedCampaignFormKeys, AutoManagedCampaignFormValues } from '../types';

export const Rates = () => {
  const { t } = useTranslation();
  const { watch, setValue } = useFormContext<AutoManagedCampaignFormValues>();

  const [marginRateValue, commissionRateValue, influencerCommissionRateValue] = watch([
    'marginRate',
    'commissionRate',
    'influencerCommissionRate'
  ]);

  useEffect(() => {
    const marginRate = Number(marginRateValue || 0);
    const influencerCommissionRate = commissionRateValue ? ((100 - marginRate) * commissionRateValue) / 100 : null;

    setValue('influencerCommissionRate', influencerCommissionRate);
  }, [marginRateValue, commissionRateValue]);

  return (
    <>
      <Form.SectionTitle index={2} label={t('Commission rate / Margin rate')} />

      <Form.Fields itemsPerRow={4}>
        <Form.Field>
          <Label
            className={styles.label}
            help={t('Tooltip.commissionRateHelp')}
            title={t<string>('TextForm.Commission Rate')}
          />
          <p className={styles.text}>{formatPercent(commissionRateValue, false)}%</p>
        </Form.Field>

        <TextField<AutoManagedCampaignFormKeys>
          rightSection="%"
          name="marginRate"
          placeholder="10"
          numberWithDecimals
          className={styles.textForm}
          title={t('TextForm.AnyMind Margin Rate')}
          help={t('Tooltip.AutoManagedAnyMindMarginRate')}
        />

        <Form.Field>
          <Label
            className={styles.label}
            help={t('Tooltip.influencerCommissionRateHelp')}
            title={t('TextForm.Influencer Commission Rate')}
          />
          <p className={styles.text}>{formatPercent(influencerCommissionRateValue, false)}%</p>
        </Form.Field>
      </Form.Fields>
    </>
  );
};

const styles = {
  text: cn('text-base'),
  textForm: cn('[&_label]:text-base'),
  label: cn('mb-2 p-0 text-base')
};
